import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { defaultTemplate } from "common/hoc";
import { MrbRouterLink } from "mrb/core/infrastructure/router";

function UserCertifiedModeInfoModalTemplate({ modalParams, t, hideDevicesLink }) {
    return (
        <MrbModal
            className="modal__content modal__content--xlrg"
            modalParams={modalParams}
            shouldCloseOnOverlayClick={true}
            displayCloseIcon={true}
        >
            <div className="u-type--base u-mar--top--sml">
                <p className="u-mar--bottom--sml">
                    {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.DESCRIPTION")}
                </p>

                <div className="c-card--sml c-card--secondary u-type--base u-mar--bottom--sml">
                    <strong>{t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.THE_NAKI_STANDARD")}</strong>
                    <br />
                    <p className="u-type--color--text--lighter">
                        {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.THE_NAKI_STANDARD_DESCRIPTION")}
                    </p>
                </div>

                <div className="c-card--sml c-card--secondary u-type--base u-mar--bottom--sml">
                    <strong>{t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.WHITELIST_MODE")}</strong>
                    <p className="u-type--color--text--lighter">
                        {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.WHITELIST_MODE_DESCRIPTION")}
                    </p>
                    <div className="u-display--flex">
                        <p className="c-validation--info u-mar--top--tny">
                            {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.WHITELIST_MODE_NOTE")}
                        </p>
                    </div>
                </div>

                <div className="c-card--sml c-card--secondary u-type--base u-mar--bottom--sml">
                    <strong>{t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CERTIFIED_MODE.INFO_MODAL.TITLE")}</strong>
                    <br />
                    <p className="u-type--color--text--lighter">
                        {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CERTIFIED_MODE.INFO_MODAL.DESCRIPTION")}
                    </p>
                </div>

                <p className="u-mar--bottom--tny">
                    {hideDevicesLink ? (
                        t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.FOOTER_DESCRIPTION_SHORT")
                    ) : (
                        <React.Fragment>
                            {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.FOOTER_DESCRIPTION_PART_ONE")}{" "}
                            <MrbRouterLink routeName="master.application.device.list">
                                {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.FOOTER_DESCRIPTION_PART_TWO")}
                            </MrbRouterLink>{" "}
                            {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CONTENT_MODES.FOOTER_DESCRIPTION_PART_THREE")}
                        </React.Fragment>
                    )}
                </p>
            </div>
        </MrbModal>
    );
}

UserCertifiedModeInfoModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    hideDevicesLink: PropTypes.bool,
};

export default defaultTemplate(UserCertifiedModeInfoModalTemplate);
